import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Produtos from "@/pages/Produtos";
import Galeria from "@/pages/Galeria";
import Feedbacks from "@/pages/Feedbacks";
import Sobre from "@/pages/Sobre";
import Contato from "@/pages/Contato";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminProdutos from "@/pages/admin/AdminProdutos";
import AdminFeedbacks from "@/pages/admin/AdminFeedbacks";
import AdminGaleria from "@/pages/admin/AdminGaleria";
import { Toaster } from "sonner";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<><Header /><Home /><Footer /></>} />
            <Route path="/produtos" element={<><Header /><Produtos /><Footer /></>} />
            <Route path="/galeria" element={<><Header /><Galeria /><Footer /></>} />
            <Route path="/feedbacks" element={<><Header /><Feedbacks /><Footer /></>} />
            <Route path="/sobre" element={<><Header /><Sobre /><Footer /></>} />
            <Route path="/contato" element={<><Header /><Contato /><Footer /></>} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
              <Route path="dashboard" element={<AdminDashboard />} />
              <Route path="produtos" element={<AdminProdutos />} />
              <Route path="feedbacks" element={<AdminFeedbacks />} />
              <Route path="galeria" element={<AdminGaleria />} />
            </Route>
          </Routes>
          <Toaster />
        </BrowserRouter>
      </div>
    </AuthProvider>
  );
}

export default App;

